import axios from 'axios'

const broker_form = {
  namespaced: true,

  state() {
    return {
      data: {
        status: null,
        is_supervisor: null,
        email: null,
        password: null,
        name: null,
        name_kana: null,
        contact: null,
        office: null,
        department: null,
        use_two_step_authentication: false,
      },
      errors: {},
    };
  },

  getters: {
    parameters(state) {
      let data = Object.assign({}, state.data)
      if (state.data.password === null) {
        delete data.password
      }
      return data;
    },
  },

  mutations: {
    setData(state, data) {
      state.data.status = data.status;
      state.data.is_supervisor = data.is_supervisor;
      state.data.email = data.email;
      state.data.password = null;
      state.data.name = data.name;
      state.data.name_kana = data.name_kana;
      state.data.contact = data.contact;
      state.data.office = data.office;
      state.data.department = data.department;
      state.data.use_two_step_authentication = data.use_two_step_authentication;
      state.errors = {};
    },
    setErrors(state, errors) {
      state.errors = {...errors};
    },
    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
  },

  actions: {
    load({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/api/brokers/' + payload.id).then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        }).catch(() => reject());
      });
    },

    update({rootState, getters, commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/brokers/' + payload.id, getters.parameters).then((response) => {
          commit('setData', response.data.data);
          if (rootState.account.id === response.data.data.id) {
            commit('account/setData', response.data.data, {root: true});
          }
          commit('setFlashMessage', {value: '更新しました'}, {root: true});
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({handled});
        });
      });
    },

    freeze({getters, commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/brokers/${payload.id}/freeze`, getters.parameters).then(() => {
          commit('setFlashMessage', {value: '更新しました'}, {root: true});
          resolve(true);
        }).catch((error) => {
              let message = null;
              if (error.response.status === 409 && error.response.data.message.length > 0) {
                message = error.response.data.message
              }
              reject(message)
            }
        );
      });
    },

    restore({getters, commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/brokers/${payload.id}/restore`, getters.parameters).then(() => {
          commit('setFlashMessage', {value: '更新しました'}, {root: true});
          resolve(true);
        }).catch((error) => {
          let reason = {}
          if (error.response.status === 409) {
            reason = {
              conflict: true
            }
          }
          reject(reason);
        });
      });
    },
  }
};

export default broker_form;
